import { useRef, useMemo } from 'react';
import type { DSTabsInternalsT } from '../sharedTypes.js';

export const useCrossRef = (): DSTabsInternalsT.DSTabsUseCrossRefContextT => {
  const firstSubtabInternalRef = useRef<HTMLButtonElement>();
  const lastTabInternalRef = useRef<HTMLButtonElement>();

  const ctx = useMemo(
    () => ({
      firstSubtabInternalRef,
      lastTabInternalRef,
    }),
    [],
  );

  return ctx;
};
